export default ({ request }) => ({
  techCuttingInfoListApi(data = {}) {
    return request({
      url: '/factory/tech/cutting/info/list',
      method: 'post',
      data,
    })
  },
  techCuttingInfoDetailApi(data = {}) {
    return request({
      url: '/factory/tech/cutting/info/detail',
      method: 'post',
      data,
    })
  },
  techCuttingInfoDelApi(data = {}) {
    return request({
      url: '/factory/tech/cutting/info/del',
      method: 'post',
      data,
    })
  },
  techCuttingInfoAddOrderApi(data = {}) {
    return request({
      url: '/factory/tech/cutting/info/addTechCuttingByOrder',
      method: 'post',
      data,
    })
  },
  // techCuttingInfoAddSaveApi(data = {}) {
  //   return request({
  //     url: '/factory/tech/cutting/info/add/save',
  //     method: 'post',
  //     data,
  //   })
  // },
  techCuttingInfoEditSaveApi(data = {}) {
    return request({
      url: '/factory/tech/cutting/info/edit/save',
      method: 'post',
      data,
    })
  },

  techCuttingSubmitApi(data = {}) {
    return request({
      url: '/factory/tech/cutting/info/submit',
      method: 'post',
      data,
    })
  },


  techCuttingInfoDetailListApi(data = {}) {
    return request({
      url: '/factory/tech/cutting/info/detail/list',
      method: 'post',
      data,
    })
  },

  techCuttingInfoDetailDelApi(data = {}) {
    return request({
      url: '/factory/tech/cutting/info/detail/del',
      method: 'post',
      data,
    })
  },
  techCuttingInfoGetFabricListApi(data = {}) {
    return request({
      url: '/factory/tech/cutting/info/detail/getOrderFabricList',
      method: 'post',
      data,
    })
  },
  techCuttingInfoDetailAddApi(data = {}) {
    return request({
      url: '/factory/tech/cutting/info/detail/add',
      method: 'post',
      data,
    })
  },

  techCuttingInfoGoodsListApi(data = {}) {
    return request({
      url: '/factory/tech/cutting/info/goods/list',
      method: 'post',
      data,
    })
  },
  techCuttingInfoGoodsDetailApi(data = {}) {
    return request({
      url: '/factory/tech/cutting/info/goods/detail',
      method: 'post',
      data,
    })
  },
  techCuttingInfoGoodsDelApi(data = {}) {
    return request({
      url: '/factory/tech/cutting/info/goods/del',
      method: 'post',
      data,
    })
  },
  techCuttingInfoGoodsSaveApi(data = {}) {
    return request({
      url: '/factory/tech/cutting/info/goods/save',
      method: 'post',
      data,
    })
  },
  techCuttingImageListApi(data = {}) {
    return request({
      url: '/factory/tech/cutting/image/list',
      method: 'post',
      data,
    })
  },
  techCuttingImageDelApi(data = {}) {
    return request({
      url: '/factory/tech/cutting/image/del',
      method: 'post',
      data,
    })
  },
  techCuttingImageSaveApi(data = {}) {
    return request({
      url: '/factory/tech/cutting/image/batch/upload',
      method: 'post',
      data,
    })
  },



})
